import { reportService } from '@/domain/services/report/reportService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class AppealUserReportUseCase {
  async execute(comment: string): Promise<boolean> {
    try {
      return await reportService.appealReportedUser(comment);
    } catch (error) {
      appLogger.error('Error appealing user report', 'AppealUserReportUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const appealUserReportUseCase = new AppealUserReportUseCase();
